import { ReactElement } from "react";

export interface BiometryProps {
  status: BiometryStatus;
  status_text: string;
}

export interface BiometryComponentProps {
  title: string | ReactElement;
  onSubmit: () => Promise<void>;
  loading: boolean;
  manualWaiting?: boolean;
  biometry?: BiometryProps;
}

export enum BiometryStatus {
  Waiting = 1,
  Success = 2,
  Unsuccessful = 3,
  Error = 4,
  Expired = 5,
  Blocked = 6,
}
